import AsyncStorage from '@react-native-async-storage/async-storage';
import React, {useEffect, useState} from 'react';
import {Platform, Dimensions} from 'react-native';
import axios from 'axios';

import {
  NavigationContainer,
  createNavigationContainerRef,
} from '@react-navigation/native';

import {createNativeStackNavigator} from '@react-navigation/native-stack';

import * as SplashScreen from 'expo-splash-screen';
import {setCustomText} from 'react-native-global-props';

// Screens
import SplashScreens from './SplashScreen';
import SignInScreen from './screens/SignInScreen';
import Root from '../src/Root';
import Guest from '../src/Guest';
import webHomeScreen from './screens/webHomeScreen';

// Prevent splash auto hide
SplashScreen.preventAutoHideAsync();

const windowWidth = Dimensions.get('window').width;

const Stack = createNativeStackNavigator();

export const navigationRef = createNavigationContainerRef();

export default function Navigation() {
  const [initialRoute, setInitialRoute] = useState('SplashScreen');
  const [loading, setLoading] = useState(true);

  // Default Bangla font
  const defaultFonts = () => {
    const customTextProps = {
      style: {
        fontFamily: 'SolaimanLipi',
      },
    };

    setCustomText(customTextProps);
  };

  // Check local login
  const checkLogin = async () => {
    try {
      const user = await AsyncStorage.getItem('user_name');
      const pass = await AsyncStorage.getItem('user_password');

      if (user && pass) {
        setInitialRoute('Root');
      } else {
        setInitialRoute('Auth');
      }
    } catch (error) {
      console.log(error);
      setInitialRoute('Auth');
    } finally {
      setLoading(false);
    }
  };

  // Auto login from URL token
  const autoLoginFromUrl = async () => {
    try {
      if (typeof window === 'undefined') {
        await checkLogin();
        return;
      }

      const params = new URLSearchParams(window.location.search);

      const token = params.get('token');

      // no token
      if (!token) {
        await checkLogin();
        return;
      }

      // decode token
      let decoded = '';

      try {
        decoded = atob(token);
      } catch (e) {
        console.log('Invalid token');
        await checkLogin();
        return;
      }

      const splitData = decoded.split('&pass=');

      if (splitData.length < 2) {
        console.log('Token invalid format');
        await checkLogin();
        return;
      }

      const userId = splitData[0];
      const passToken = splitData[1];

      console.log('Auto Login User:', userId);

      const formData = new URLSearchParams();

      formData.append('apps_user_type', '2');
      formData.append('username', userId);
      formData.append('password', passToken);

      const response = await axios.post(
        'https://webapi.bdlawservice.com/public/api/appsAndWebLogin',
        formData,
      );

      console.log('Login Response:', response.data);

      if (response.data.code === 200 || response.data.code === 504) {
        // clear old data
        await AsyncStorage.clear();

        // save login
        await AsyncStorage.setItem('user_name', JSON.stringify(userId));

        await AsyncStorage.setItem('user_id', JSON.stringify(userId));

        await AsyncStorage.setItem(
          'user_password',
          btoa(new Date() + passToken),
          // JSON.stringify(passToken),
        );

        // save profile info
        if (response.data.user_info) {
          await AsyncStorage.setItem(
            'name',
            JSON.stringify(response.data.user_info.name || ''),
          );

          await AsyncStorage.setItem(
            'mobile_no',
            JSON.stringify(response.data.user_info.mobile_no || ''),
          );
        }
        window.location.href = '/';
        setInitialRoute('Root');
      } else {
        setInitialRoute('Auth');
      }
    } catch (error) {
      console.log(error);

      setInitialRoute('Auth');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    defaultFonts();

    autoLoginFromUrl();
  }, []);

  // Auth Stack
  const Auth = () => {
    return (
      <Stack.Navigator initialRouteName="SignInScreen">
        <Stack.Screen
          name="SignInScreen"
          component={SignInScreen}
          options={{
            headerShown: false,
          }}
        />
      </Stack.Navigator>
    );
  };

  // Web Home
  const AuthWeb = () => {
    return (
      <Stack.Navigator initialRouteName="WebHome">
        <Stack.Screen
          name="WebHome"
          component={webHomeScreen}
          options={{
            headerShown: false,
          }}
        />
      </Stack.Navigator>
    );
  };

  if (loading) {
    return null;
  }

  return (
    <NavigationContainer ref={navigationRef}>
      <Stack.Navigator initialRouteName={initialRoute}>
        {/* Splash */}
        <Stack.Screen
          name="SplashScreen"
          component={SplashScreens}
          options={{
            headerShown: false,
          }}
        />

        {/* Auth */}
        {/* <Stack.Screen
          name="Auth"
          component={Auth}
          options={{
            headerShown: false,
          }}
        /> */}

        {/* Web */}
        <Stack.Screen
          name="Guest"
          component={Guest}
          options={{
            headerShown: false,
          }}
        />

        {/* Main App */}
        <Stack.Screen
          name="Root"
          component={Root}
          options={{
            headerShown: false,
          }}
        />
      </Stack.Navigator>
    </NavigationContainer>
  );
}
